export default function Obsession() {
  return (
    <section className="obsession" id="obsession">
      <div className="obsession__label">03 — OBSESSION</div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: '40px' }}>
        <div>
          <h2 className="obsession__head">
            OBSESSION.<span className="obsession__dot" />
          </h2>
        </div>

        <div style={{ maxWidth: '400px', paddingBottom: '8px' }}>
          <p className="obsession__sub">
            The details nobody sees.<br />
            The quality everybody feels.
          </p>
          <p className="obsession__sub" style={{ marginTop: '20px' }}>
            We are not satisfied with "good enough".<br />
            We are chasing something harder.<br />
            That's what makes the work alive.
          </p>
        </div>
      </div>

      <div style={{
        width: '100%',
        height: '1px',
        background: 'linear-gradient(90deg, transparent, #CC1F1A 50%, transparent)',
        marginTop: '80px',
        opacity: 0.4,
      }} />
    </section>
  );
}
